import { AloDbMissionVirtual } from '@/models/alodb/AloDbMissionVirtual'
import { FilterBase } from '@/models/filter/FilterBase'

export interface IMissionVirtualState {
    status:string
    missionVirtuals: Array<AloDbMissionVirtual>
    modifiedAdmMissionVirtual: AloDbMissionVirtual
    originalAdmMissionVirtual: AloDbMissionVirtual
    missionVirtualLoading: boolean
    adminFilter: FilterBase
    showDialogSimulationFinished: string
    vimLaunchDic:{[index:number]:boolean}
}
  
const state:IMissionVirtualState = { 
    status: '',
    missionVirtuals: [],
    modifiedAdmMissionVirtual: new AloDbMissionVirtual(),
    originalAdmMissionVirtual: new AloDbMissionVirtual(),
    missionVirtualLoading:false,
    adminFilter: new FilterBase(),
    showDialogSimulationFinished: '',
    vimLaunchDic:{}
}
  
export default state